import { memo } from "react";

import { DeleteNotificationsDropdown } from "./local-components/delete-notifications-dropdown";
import { MarkAllReadButton } from "./local-components/mark-all-read-button";
import { NotificationsEmailSwitch } from "./local-components/notifications-email-switch";
import { NotificationsList } from "./local-components/notifications-list";
import { NotificationsPanelTitle } from "./local-components/notifications-panel-title";

export const NotificationsPanel = memo(() => (
  <div className="flex min-h-0 flex-1 flex-col gap-4">
    <NotificationsPanelTitle />

    <div className="flex items-center justify-between gap-4">
      <div className="flex min-w-0 items-center gap-4">
        <MarkAllReadButton />
        <NotificationsEmailSwitch />
      </div>

      <DeleteNotificationsDropdown />
    </div>

    <NotificationsList />
  </div>
));

NotificationsPanel.displayName = "NotificationsPanel";
